import { useSelector } from 'react-redux';
import { isDefined } from '../utils';
import { getSelectedEditableAssignments } from '../instruction-hub/instruction-hub-assignments';

export default function useAssignmentsToUnassign() {
  const assignmentsToUnassign = useSelector((state) =>
    getSelectedEditableAssignments(
      state.CourseAssignReducer.assignments.studentAssignments,
      state.CourseAssignReducer.instructionHubBlockedLookup
    ).filter(
      (assignment) =>
        assignment.assignment && isDefined(assignment.assignment.assignStatus)
    )
  );
  return assignmentsToUnassign;
}



// WEBPACK FOOTER //
// ./helpers/hooks/use-assignment-to-unassign.js